import * as yup from "yup";

const validations = yup.object().shape({
  name: yup.string().required("Campo não-preenchido"),
  payment: yup.string().required("Campo não-preenchido"),
  notes: yup.string().max(150, "Limite de caracteres ultrapassado"),
});

export default validations;
